import React, { useState, useEffect, useRef, forwardRef, useImperativeHandle } from "react";
import Hexapi from "../utility/HexAPI/Hexapi";
import Table from "react-bootstrap/Table";
import { Spinner } from "react-bootstrap";
import { Modal } from "react-bootstrap";
import "react-confirm-alert/src/react-confirm-alert.css";
import Swal from "sweetalert2";
import "./show.css";
import DataTable from "./table/DataTable";
import ActionModal from "./actionmodal";

const Show = forwardRef((props, ref) => {
  const {
    cidarray: cidarrayProp,
    processeddata: processeddataProp,
    agentid,
    tableRef,
    headerkeys,
    header,
    isnewvalue,
    Selectedrowindex,
    refreshtable,
    refreshtableset,
    callfunction,
  } = props;

  const [modalshow, setModalshow] = useState(false);
  const [enquiryshow, setEnquiryshow] = useState(false);
  const [productList, setProductList] = useState([]);
  const [usageshow, setUsageshow] = useState(false);
  const [usageshowOpen, setUsageshowOpen] = useState(false);
  const [quotationshow, setQuotationshow] = useState(false);
  const [callStatusOptions, setCallStatusOptions] = useState([]);
  const [updatedate, setUpdatedate] = useState("");
  const [nextstep, setNextstep] = useState("");
  const [remark, setRemark] = useState("");
  const [contactphonebook, setContactphonebook] = useState("");
  const [contactphonebookname, setContactphonebookname] = useState("");
  const [countrycodephonebook, setCountrycodephonebook] = useState("+91");
  const [chances, setChances] = useState("");
  const [EnquiryConclusion, setEnquiryConclusion] = useState("");
  const [ClosingRemarks, setClosingRemarks] = useState("");
  const [ClosingDate, setClosingDate] = useState(new Date().toJSON().slice(0, 10));
  const [opensubscription, setOpensubscription] = useState(false);
  const [updatekeys, setUpdatekeys] = useState([]);
  const [updateheaderrow, setUpdateheaderrow] = useState([]);
  const [labelupdate, setLabelupdate] = useState([]);
  const [labelinputupdate, setLabelinputupdate] = useState([]);
  const [stageprogress, setStageprogress] = useState([]);
  const [found, setFound] = useState(false);
  const [Stageconclusion, setStageconclusion] = useState([]);
  const [recid, setRecid] = useState("");
  const [showDateInput, setShowDateInput] = useState(false);
  const [stageid, setStageid] = useState("");
  const [closestatus, setClosestatus] = useState("-1");
  const [isModalQueryHitComplete, setIsModalQueryHitComplete] = useState(true);
  const [isapihitcomplete, setIsapihitcomplete] = useState(false);
  const [isapihitcompleteUsage, setIsapihitcompleteUsage] = useState(false);
  const [isdatafound, setIsdatafound] = useState(false);
  const [isdatafoundUsage, setIsdatafoundUsage] = useState(false);
  const [call, setCall] = useState("");
  const [customerid, setCustomerid] = useState("");
  const [hasHandledNext, setHasHandledNext] = useState(false);
  const [usersqty, setUsersqty] = useState(0);
  const [AgentList, setAgentList] = useState([]);
  const [productSelected, setProductSelected] = useState(0);
  const [productID, setProductID] = useState(0);
  const [agentID] = useState(agentid);
  const [leadwithID, setLeadwithID] = useState(0);

  const [appusercount, setAppusercount] = useState("");

  const [cidarray, setCidarray] = useState(cidarrayProp || []);
  const [currentindex, setCurrentindex] = useState(0);
  const [selectedRowIndex, setSelectedRowIndex] = useState(Selectedrowindex);

  const [selectedOption, setSelectedOption] = useState(null);
  const [showoption, setShowoption] = useState(false);

  const [refresh, setRefresh] = useState(0);

  const [notification, setNotification] = useState(null);
  const [showModal, setShowModal] = useState(false);
  const [selectedEnquiryId, setSelectedEnquiryId] = useState(null);
  const [processeddata, setProcesseddata] = useState(processeddataProp);
  const [updateshow, setUpdateshow] = useState(false);

  const childRef = useRef(null);
 


  useEffect(() => {
    setCidarray(cidarrayProp);
    setCurrentindex(0);
  }, [cidarrayProp]);


  const prevHeaderRef = useRef(header);
  useEffect(() => {
    if (prevHeaderRef.current === header) {
      const tableEl = tableRef?.current;
      if (tableEl) {
        const highlightedRows = tableEl.querySelectorAll(".highlighted");
        highlightedRows.forEach((row) => row.classList.remove("highlighted"));

        if (Selectedrowindex !== null) {
          const rowElement = tableEl.querySelector(
            `tbody tr:nth-child(${Selectedrowindex + 1})`,
          );
          if (rowElement) {
            const tableContainer = tableEl.parentElement;
            const rowOffsetTop = rowElement.offsetTop;
            const containerHeight = tableContainer.offsetHeight;
            tableContainer.scrollTop =
              rowOffsetTop - containerHeight / 2 + rowElement.offsetHeight / 2;
            rowElement.classList.add("highlighted");
          }
        }
      }
    }
    prevHeaderRef.current = header;
  });



  
  const handleupdatemodalclose = () => {
    setUpdateshow(false);
  };


  const rowModalOpen = (s, index) => {
    setModalshow(true);
    setRecid(s.enquiryid);
    setCustomerid(s["customer id"]);
    setStageid(s.stageid);
    setCall(s["contact number"]);
    setCurrentindex(index);
    setSelectedRowIndex(index);
    setShowoption(false);
    setSelectedOption("");
    setRemark("");
  };

  // ─── subscriptionModal ──────────────────────────────────────────────────────
  const subscriptionModal = () => {
    setOpensubscription(true);
    stageprogress_fn();
  };

  // ─── enquiryModalOpen ───────────────────────────────────────────────────────
  const enquiryModalOpen = () => {
    Stageconclusion_fn();
  };

  // ─── quotationInputs ────────────────────────────────────────────────────────
  const quotationInputs = (e) => {
    // console.error(e.target.value);
    // console.error(usersqty);
  };


  // ─── handlemodalshow / handlemodalclose ────────────────────────────────────
  const handlemodalshow = () => {
    setModalshow(true);
  };

  const handlemodalclose = () => {
    setModalshow(false);
  };


  



  const Stageconclusion_fn = () => {
    setEnquiryshow(true);
    let obj = {
      query: `[dbo].[HCMS_Proc_Stage_Conclusion_GetList]`,
      queryArr: [],
    };
    Hexapi(obj).then((resp) => {
      if (resp[""].length > 0 && resp[""] != null) {
        setStageconclusion(resp[""]);
      }
    });
  };

  // ─── stageprogress ──────────────────────────────────────────────────────────
  const stageprogress_fn = () => {
    // original class had this.stageprogress() but it was not defined — keeping as no-op
  };





const filteredKeys = headerkeys.filter((k) => k !== "enquiryid");
  return (
    <>
      {modalshow && (
        <ActionModal
          currentindex={currentindex}
          refreshtableset={refreshtableset}
          refresh={refresh}
          agentid={agentID}
          processeddata={processeddata}
          cidarray={cidarray}
          handleupdatemodalclose={handleupdatemodalclose}
          handlemodalshow={handlemodalshow}
          handlemodalclose={handlemodalclose}
          ref={childRef}
          updateshow={updateshow}
          usageshow={usageshow}
          usageshowOpen={usageshowOpen}
          modalshow={modalshow}
          recid={recid}
          getQuotation={quotationInputs}
          selectedRowIndex={selectedRowIndex}
          refreshtable={refreshtable}
        />
      )}
      <Modal
        centered
        size="sm"
        id="loadingModal"
        animation={true}
        show={!isModalQueryHitComplete}
        onHide={() => setIsModalQueryHitComplete(true)}
        style={{ backgroundColor: "rgba(0,0,0,0.6)" }}
        backdrop="static"
        keyboard={false}
      >
        <Modal.Body>
          <div
            style={{
              display: "flex",
              alignItems: "center",
              padding: "8px",
              paddingBottom: "16px",
            }}
          >
            <Spinner variant="dark" animation="border" />
            <span style={{ paddingLeft: "20px" }}>Loading...</span>
          </div>
        </Modal.Body>
      </Modal>
      <div
        className="container-fluid h-100 d-flex flex-column"
        style={{ overflowX: "auto" }}
      >
        <div className="row">
          <div className="col-md-12">
            {isnewvalue == "usage" ? (
              <DataTable
                data={header}
                uppercase={false}
                inputProps={{
                  thead: {
                    backgroundColor: "rgb(18, 80, 172)",
                    color: "#fff",
                    textTransform: "capitalize",
                  },
                }}
                pagination={{
                  show: false,
                  rowsPerPage: 1,
                  rowsPerPageOptions: [
                    1,
                    3,
                    5,
                    15,
                    50,
                    100,
                    { label: "All", value: -1 },
                  ],
                }}
              />
            ) : (
              <div className="table-wrapper">
                <Table
                  ref={tableRef}
                  
                  className="table custom-table"
                >

                 <thead style={{ whiteSpace: "nowrap" }}>
  <tr style={{ background: "rgb(18 80 172)", color: "white", position: "sticky", top: "0px" }}>
    {filteredKeys.map((s, index) => (
      <th key={index}>{s.toUpperCase()}</th>
    ))}
  </tr>
</thead>
                  <tbody style={{ whiteSpace: "nowrap", cursor: "pointer" }}>
                    {header.map((s, index) => {
                      const isHighlighted = Selectedrowindex === index;
                      let keys = headerkeys;
                      // console.log(keys,"keys")
                      return (
                        <tr
                          key={index}
                          style={{ cursor: "pointer" }}
                          className={isHighlighted ? "highlighted" : ""}
                        >
                          {keys.map((data, key) => {
                            if (data != "enquiryid") {
                              if (s[data] == null) {
                                s[data] = "";
                              }
if (typeof s[data] === "object" && s[data] !== null) {
  let value = s[data]?.date ?? "";

 
  if (value === "1900-01-01 00:00:00.000000") {
    value = "";
  } else if (value) {
    const d = new Date(value);
    if (!isNaN(d)) {
      value = d.toLocaleDateString("en-GB", {
        day: "numeric",
        month: "long",
        year: "numeric",
      });
    }
  }

  return (
    <td key={key} onClick={(e) => rowModalOpen(s, index)}>
      {value}
    </td>
  );
}

                              if (data == "status") {
                                return (
                                  <td>
                                    <img
                                      style={{ width: "50%", height: "auto" }}
                                      src={`${localStorage.getItem("Apipathurl")}assets/${s[data]}.png`}
                                    />
                                  </td>
                                );
                              }

                              if (typeof s[data] != "object") {
                                return (
                                  <td
                                    key={key}
                                    id={`${data}0`}
                                    dangerouslySetInnerHTML={{ __html: s[data] }}
                                    onClick={(e) => rowModalOpen(s, index)}
                                  ></td>
                                );
                              }
                            }
                          })}
                        </tr>
                      );
                    })}
                  </tbody>
                </Table>
              </div>
            )}
          </div>
        </div>
      </div>
    </>
  );
});

export default Show;